<template>
  <quill-editor
    ref="quill"
    v-bind="$attrs"
    :value="value"
    @input="onInput"
    v-on="$listeners"
    :options="editorOption"
    @blur="onEditorBlur($event)"
    @focus="onEditorFocus($event)"
    @ready="onEditorReady($event)"
  ></quill-editor>
</template>

<script>
import { Quill, quillEditor } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";
import Upload from "@/services/modules/uploads.service";
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
export default {
  components: {
    quillEditor
  },
  props: {
    value: {
      type: [String, Number, Array]
    }
  },
  data() {
    return {
      name: "quill",
      editorOption: {
        placeholder: "Insira um texto aqui",
        modules: {
          toolbar: {
            container: [
              [, /* { font: [] } */ { size: [] }],
              ["bold", "italic", "underline", "strike"],

              [{ header: "1" }, { header: "2" }, "blockquote", "code-block"],
              [
                { list: "ordered" },
                { list: "bullet" },
                { indent: "-1" },
                { indent: "+1" }
              ],
              ["direction", { align: [] }],
              ["link", "image", "video" /* "formula" */],
              [{ color: [] }, { background: [] }],
              ["clean"]
            ],
            handlers: {
              image: this.imageHandler
            }
          },
          imageDrop: true,
          imageResize: {
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white"
            },
            modules: ["Resize", "DisplaySize", "Toolbar"]
          }
        }
      }
    };
  },
  mounted() {},
  computed: {},
  methods: {
    imageHandler(image, callback) {
      const input = document.createElement("input");

      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/*");
      input.click();

      input.onchange = async () => {
        const file = input.files[0];
        const formData = new FormData();

        formData.append("file", file);

        // Save current cursor state
        const range = this.$refs.quill.quill.getSelection(true);

        // Insert temporary loading placeholder image
        this.$refs.quill.quill.insertEmbed(
          range.index,
          "image",
          `${window.location.origin}/images/loaders/placeholder.gif`
        );

        // Move cursor to right side of image (easier to continue typing)
        this.$refs.quill.quill.setSelection(range.index + 1);

        const res = await Upload.add(formData);

        // Remove placeholder image
        this.$refs.quill.quill.deleteText(range.index, 1);

        // Insert uploaded image
        this.$refs.quill.quill.insertEmbed(range.index, "image", res.data.url);
      };
    },

    onInput(evt) {
      this.$emit("input", evt);
    },
    onEditorBlur(editor) {
      // console.log('editor blur!', editor)
    },
    onEditorFocus(editor) {
      // console.log('editor focus!', editor)
    },
    onEditorReady(editor) {
      // console.log('editor ready!', editor)
    }
  }
};
</script>

<style>
</style>
